import { defineStore } from 'pinia'

export const useOrderStoreFront = defineStore('orderStoreFront', () => {
  const { API_ENDPOINTS } = useApiEndpoints()
  const cartStore = useCartStore()
  const addressStore = useUserAddressStore()
  const paymentStore = useOrderPaymentStore()
  const toast = useCustomToast()

  const createOrderLoading = ref(false)
  const orders = ref([])
  const pagination = ref({
    current_page: 1,
    per_page: 10,
    total: 0,
    last_page: 1
  })

  // Sipariş oluşturma işlemi
  const createOrder = async () => {
    // Adres kontrolü
    if (addressStore.addresses.length == 0) {
      toast.error('Sipariş oluşturmak için adres eklemelisiniz')
      return
    }

    // Sepet kontrolü
    if (!cartStore.cartItems?.length) {
      toast.error('Sepet boş')
      return
    }

    // Ödeme yöntemi kontrolü
    if (!paymentStore.selectedPaymentMethod) {
      toast.error('Lütfen bir ödeme yöntemi seçin')
      return
    }

    // Ödeme yöntemi geçerli mi?
    if (!paymentStore.validatePaymentMethod()) {
      toast.error('Seçilen ödeme yöntemi geçersiz')
      return
    }

    const newOrderObj = {
      address_id: addressStore.defaultAddress.id,
      cart: cartStore.cart,
      payment_method: paymentStore.selectedPaymentMethod
    }

    createOrderLoading.value = true
    try {
      const response = await useBaseOFetchWithAuth(
        API_ENDPOINTS.protected.orders.create,
        {
          method: 'POST',
          body: JSON.stringify(newOrderObj)
        }
      )

      // Başarılı sipariş sonrası işlemler
      await _handleSuccessfulOrder(response)
    } finally {
      createOrderLoading.value = false
    }
  }

  // Başarılı sipariş sonrası işlemleri
  const _handleSuccessfulOrder = async (response) => {
    cartStore.clearCart()
    await navigateTo({
      path: '/tesekkurler',
      query: {
        orderId: response.order_id
      }
    })
  }

  // Sipariş listesini getir
  const getOrders = async (page = 1) => {
    const response = await useBaseOFetchWithAuth(
      `${API_ENDPOINTS.protected.orders.list}?page=${page}`
    )
    
    // API'den gelen verileri kaydet
    orders.value = response.data || []
    
    // Sayfalama bilgilerini güncelle
    if (response.pagination) {
      pagination.value = response.pagination
    }
    
    return response
  }

  const getOrder = async (orderId) => {
    const response = await useBaseOFetchWithAuth(
      API_ENDPOINTS.protected.orders.get(orderId)
    )
    return response
  }

  return {
    // State
    orders,
    pagination,
    createOrderLoading,

    // Actions
    createOrder,
    getOrders,
    getOrder
  }
})
